import React, { useEffect, useState } from "react"

function getImageProps(image){
  let url = image;
  const validImageUrlPattern = /^(https?:)?\/\/a.storyblok.com\/f\/*[0-9]+\/*[0-9]*x*[0-9]*\/[A-Za-z0-9]+\/[\S]+\.[a-zA-Z]+/
  const storyblokRegex = /^(https?:)?\/\/a.storyblok.com\//
  url = validImageUrlPattern.test(url) ? url : null

  if (!url) {
    return false
  }

  let originalPath = url.replace(storyblokRegex, '')

  let [, , dimensions, , filename] = originalPath.split('/')
  let [width, height] = dimensions.split('x').map((num) => parseInt(num, 10))
  let [, extension] = filename.split('.')

  let aspectRatio = width / height
  let metadata = { dimensions: { width, height, aspectRatio } }

  return {
    originalPath,
    extension,
    metadata
  }

}

function StoryblokImage({sbImageData,cropWidth,cropHeight,smartCrop,width,height,maxWidth}) {
  const [imgUrl,setUrl] = useState()
  const [imgAlt, setAlt] = useState("")
  function addSbProps(url) {
    // SB Image can't handle svg images.
    if(!url){return ""}
    if(url.endsWith('.svg')) {
      return url
    }
    let current = url+'/m'
    if(cropWidth && cropHeight) {
      current += `/${cropWidth}x${cropHeight}`
    } else if (cropWidth) {
      current += `/${cropWidth}x0`
    } else if(cropHeight) {
      current += `/0x${cropHeight}`
    }
    if(smartCrop) {
      current += '/smart'
    }
    
    // If no other changes to the url atleast add server-side webp detection
    if(current.endsWith('/m')) {
      current += '/'
    }
    return current
  }

  useEffect(()=>{
    if(sbImageData) {
      let adjustedUrl = sbImageData.filename
      adjustedUrl = addSbProps(adjustedUrl)
      setUrl(adjustedUrl)
      setAlt(sbImageData.alt)
    }
  },[sbImageData])

  let withStyle={
    margin: "auto",
    height: height ? height+'px' : 'auto'
  }
  if(width) {
    withStyle.width = width+'px'
  } 
  else if (maxWidth) {
    if(maxWidth != 'unset') {
      withStyle.maxWidth = maxWidth+'px'
    }
    else {
      withStyle.maxWidth = maxWidth
    }
    
  }
  else {
    withStyle.maxWidth = '100%'
  }

  
  let displayWidth = cropWidth ? cropWidth: "100%";
  let displayHeight = cropHeight ? cropHeight: "auto";
  let props = sbImageData? getImageProps(sbImageData.filename) : null;
  if(props){
    if(props.extension !== 'svg'){
      displayWidth = cropWidth ? cropWidth : props.metadata.dimensions.width;
      displayHeight = cropHeight ? cropHeight : props.metadata.dimensions.height;
    }
  }
  

  return imgUrl ? <img src={imgUrl} alt={imgAlt} width={displayWidth} height={displayHeight} style={withStyle} loading="lazy" /> : null
}

export default StoryblokImage